import { render, staticRenderFns } from "./SupplierOverview.vue?vue&type=template&id=35f332e3"
import script from "./SupplierOverview.vue?vue&type=script&lang=ts"
export * from "./SupplierOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports